export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\"/><g stroke=\"#3F4450\" stroke-linejoin=\"round\" transform=\"translate(1.5 .5)\"><path d=\"M0 0h13v14.5H0z\"/><path d=\"M2 2h9v8.5H2z\"/><path d=\"M4 10.405v-1.53A.915.915 0 014.955 8h3.09A.915.915 0 019 8.875v1.53\"/><circle cx=\"6.5\" cy=\"5\" r=\"1.5\"/></g></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};